import { Component, OnInit, inject } from '@angular/core';
import { TIPPY_REF } from '@ngneat/helipopper';

@Component({
  selector: 'app-linked-stages-tooltip',
  templateUrl: './linked-stages-tooltip.component.html',
  styleUrls: ['./linked-stages-tooltip.component.scss'],
})
export class LinkedStagesTooltipComponent implements OnInit {
  tippy = inject(TIPPY_REF);

  constructor() {}

  ngOnInit() {}
}
